<template>
  <svg
    role="img"
    aria-label="transcript icon"
    class="transcript-icon o-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26 26"
  >
    <title>Transcript</title>
    <path
      d="M21.3512 24H4.50018C3.0772 24 1.92571 22.8485 1.92571 21.4255V4.57447C1.92571 3.15149 3.0772 2 4.50018 2H21.3512C22.7742 2 23.9257 3.15149 23.9257 4.57447V21.4255C23.9257 22.8485 22.7742 24 21.3512 24ZM4.50018 3.40426C3.85423 3.40426 3.32997 3.92851 3.32997 4.57447V21.4255C3.32997 22.0715 3.85423 22.5957 4.50018 22.5957H21.3512C21.9972 22.5957 22.5215 22.0715 22.5215 21.4255V4.57447C22.5215 3.92851 21.9972 3.40426 21.3512 3.40426H4.50018Z"
      fill="currentColor"
    />
    <path
      d="M20.1859 19H5.66554C5.2611 19 4.92571 18.5467 4.92571 18C4.92571 17.4533 5.2611 17 5.66554 17H20.1859C20.5903 17 20.9257 17.4533 20.9257 18C20.9257 18.5467 20.5903 19 20.1859 19Z"
      fill="currentColor"
    />
    <path
      d="M11.2988 13.856L10.9383 12.7627H7.86918L7.50863 13.8763C7.36793 14.3116 7.24481 14.6052 7.14808 14.757C7.05134 14.9089 6.88426 14.9899 6.65561 14.9899C6.46215 14.9899 6.29506 14.9089 6.14556 14.7469C5.99607 14.5849 5.92571 14.4027 5.92571 14.2002C5.92571 14.0787 5.9433 13.9573 5.97848 13.8358C6.01365 13.7143 6.06642 13.5321 6.14556 13.3093L8.08024 7.66029C8.133 7.49831 8.20335 7.30596 8.2825 7.07312C8.36164 6.84027 8.44079 6.65804 8.52873 6.50619C8.61667 6.35433 8.73099 6.23285 8.87169 6.14173C9.0124 6.05062 9.18828 6 9.39933 6C9.61039 6 9.78627 6.05062 9.93576 6.14173C10.0853 6.23285 10.1908 6.35433 10.2787 6.49606C10.3667 6.6378 10.437 6.79978 10.4986 6.97188C10.5601 7.14398 10.6393 7.3667 10.7272 7.65017L12.6971 13.2587C12.8554 13.6839 12.9257 13.9978 12.9257 14.1901C12.9257 14.3825 12.8554 14.5748 12.7059 14.7469C12.5564 14.919 12.3805 15 12.1782 15C12.0551 15 11.9584 14.9798 11.8704 14.9291C11.7825 14.8785 11.7121 14.8076 11.6506 14.7267C11.589 14.6457 11.5275 14.5141 11.4659 14.3318C11.4044 14.1496 11.3428 13.9977 11.29 13.8661L11.2988 13.856ZM8.26491 11.4364H10.525L9.39054 7.85264L8.2737 11.4364H8.26491Z"
      fill="currentColor"
    />
  </svg>
</template>

<style lang="scss" scoped>
.transcript-icon {
  height: 28px;
  width: 28px;
}
</style>
